import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd" transform="translate(6 8)">
      <path
        className="stroke-change"
        stroke="#979797"
        strokeLinecap="round"
        strokeWidth="3"
        d="M0 28c4 2 10 3 18 3s14-1 18-3"
      />
      <path
        className="stroke-change"
        stroke="#979797"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M12 30l2-7c1.332.333 2.665.5 4 .5s2.668-.167 4-.5l2 7"
      />
      <circle className="fill-change" cx="11.5" cy="9.5" r="1.5" fill="#9F9F9F" />
      <path
        className="stroke-change"
        stroke="#979797"
        strokeWidth="3"
        d="M4 28.5l3.582-11.195A1 1 0 0 0 6.63 16H3.72a1 1 0 0 1-.948-.684L1.26 10.778a1 1 0 0 1 .453-1.185l5.956-3.4a1 1 0 0 0 .453-.553l1.514-4.544a1 1 0 0 1 1.408-.572C14.158 2.137 16.143 3.63 17 5c.867 1.387 1.22 3.872 1.06 7.455a1 1 0 0 0 .998 1.045h4.332a6 6 0 0 1 5.798 4.454L32 28.5"
      />
    </g>
  </svg>
);
